import API_URLS from "@constants/api.urls";

import { getRequest, putRequest } from "../baseApi";

export const postUserInformation = reqBody => putRequest(API_URLS.userInformation, reqBody);

export const getUserInformation = () => getRequest(API_URLS.userInformation);
